<template>
  <div>
    <div class="kd-header">
      <div class="kd-content">
        <a class="kd-header__logo" href="/" title="LogTracing"></a>
        <ul class="kd-header__navs">
          <li v-for="me in menus" :key="me.value" class="kd-header__nav" v-bind:class="{'kd-header__nav--active': active_menu(me.value)}" :role="me.value"><router-link :to="{ name: me.value }"><span>{{ me.name }}</span></router-link></li>
        </ul>
      </div>
    </div>
    <div class="kd-header kd-header--fixed" style="left: 0px; display: none; z-index: 99;">
      <div class="kd-content">
        <a class="kd-header__logo" href="/" title="LogTracing"></a>
        <ul class="kd-header__navs">
          <li v-for="me in menus" :key="me.value" class="kd-header__nav" v-bind:class="{'kd-header__nav--active': active_menu(me.value)}" :role="me.value"><router-link :to="{ name: me.value }"><span>{{ me.name }}</span></router-link></li>
        </ul>
      </div>
    </div>
    <!-- <div class="toolbar mobile-screen">
      <a id="t-index" class="active">
        <div class="ico"></div>
        <div class="txt">Tra cứu</div>
      </a>
      <a id="t-courier" href="#">
        <div class="ico"></div>
        <div class="txt">Hàng vô chủ</div>
      </a>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      menus: [
        {value: 'trang-chu', name: 'Tra cứu'},
        {value: 'hang-vo-chu', name: 'Hàng vô chủ'}
      ]
    }
  },
  computed: {
    currentPath() {
      return this.$route.path;
    },
  },
  methods: {
    active_menu(menu) {
      let parts = this.currentPath.split('/');
      let lastSegment = parts.pop() || parts.pop();
      return (lastSegment == menu) || (lastSegment == '' && menu == 'trang-chu');
    }
  },
  mounted() {
    this.$root.$emit('COMPONENT_LOADED');
  }
}
</script>